import React from 'react';
import ItemElement from '../ItemElement';
import './TeamMember.css';
var defaultProps = {
  as: 'horizontalItem',
  cardInlinePhoto: false,
  charLimit: 300,
  description: '',
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  role: '',
  verticalItemAlign: 'center'
};
export default function TeamMember(_ref) {
  var as = _ref.as,
    name = _ref.name,
    role = _ref.role,
    description = _ref.description,
    charLimit = _ref.charLimit,
    image = _ref.image,
    cardInlinePhoto = _ref.cardInlinePhoto,
    imageCircular = _ref.imageCircular,
    imageSize = _ref.imageSize,
    itemButtonFloat = _ref.itemButtonFloat,
    itemCenterContent = _ref.itemCenterContent,
    link = _ref.link,
    linkAs = _ref.linkAs,
    verticalItemAlign = _ref.verticalItemAlign;
  return /*#__PURE__*/React.createElement("div", {
    className: "team-member"
  }, /*#__PURE__*/React.createElement(ItemElement, {
    as: as,
    header: name,
    subheader: role,
    content: description,
    charLimit: charLimit,
    image: image,
    cardInlinePhoto: cardInlinePhoto,
    imageCircular: imageCircular,
    imageSize: imageSize,
    itemButtonFloat: itemButtonFloat,
    itemCenterContent: itemCenterContent,
    link: link,
    linkAs: linkAs,
    verticalItemAlign: verticalItemAlign
  }));
}
TeamMember.defaultProps = defaultProps;